import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Navbar.css';
import HireModal from './hire.js'; // Ensure this matches your file name exactly

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <motion.nav
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}
      >
        <motion.div
          className="logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {/* SVG Logo */}
          <svg
            width="60"
            height="60"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Gradient */}
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#c5e815" />
                <stop offset="50%" stopColor="#5be8b0" />
                <stop offset="100%" stopColor="#15e8a2" />
              </linearGradient>
            </defs>

            {/* Code Bracket Icon */}
            <path
              d="M75 50
                Q45 50 45 75
                T75 100
                Q105 100 105 125
                T75 150"
              stroke="url(#gradient)"
              strokeWidth="18"
              fill="none"
              strokeLinecap="round"
            />

            {/* Text */}
            <text
              x="50%"
              y="85%"
              textAnchor="middle"
              fontFamily="Montserrat, sans-serif"
              fontSize="22"
              fontWeight="600"
              fill="url(#gradient)"
            >
              {/* SANOJ */}
            </text>
          </svg>
        </motion.div>

        <div className="nav-container">
          <div className="hamburger" onClick={toggleMobileMenu}>
            <div />
            <div />
            <div />
          </div>
          <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
            {['About', 'Projects', 'Skills', 'Contact'].map((item) => (
              <motion.li key={item} whileHover={{ y: -3 }} whileTap={{ y: 0 }}>
                <a href={`#${item.toLowerCase()}`} onClick={(e) => {
                  e.preventDefault(); 
                  const section = document.getElementById(item.toLowerCase());
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}>
                  {item}
                </a>
              </motion.li>
            ))}
          </ul>

          <motion.button
            className="contact-button"
            whileHover={{ scale: 1.05, backgroundColor: '#15e8a2' }}
            whileTap={{ scale: 0.95 }}
            onClick={openModal}
          >
            Notes
          </motion.button>
        </div>
      </motion.nav>

      {/* Hire Me Modal */}
      <HireModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Navbar;
